export enum MdrContactDetailsSource {
  CUSTOM,
  PARTNER_CONTACT,
  GZ_ACCOUNT,
}

export type MdrContactImportSourceType = MdrContactDetailsSource.PARTNER_CONTACT | MdrContactDetailsSource.GZ_ACCOUNT;

export interface MdrContactImportAccount {
  companyId: string;
  accountId?: string;
}

export interface MdrContactImportSource {
  importSource: MdrContactImportSourceType;
  importAccount: MdrContactImportAccount;
}

export type MdrContactImportSourceValue =
  | { importedCompanyId?: never; importedAccountId?: never }
  | { importedCompanyId: string; importedAccountId?: never }
  | { importedCompanyId?: never; importedAccountId: string };
